var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2177_21707)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H8C3.58172 0 0 3.58172 0 8V52C0 56.4183 3.58172 60 8 60H52C56.4183 60 60 56.4183 60 52V8C60 3.58172 56.4183 0 52 0Z",
    fill: "url(#paint0_linear_2177_21707)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2177_21707",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 46,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0029 7.37248L7.37549 29.9999L30.0029 52.6273L52.6303 29.9999L30.0029 7.37248Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2177_21707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3688 20.5306C39.62 20.7818 39.8182 21.0809 39.9517 21.4101C40.0852 21.7393 40.1512 22.0919 40.1459 22.4471C40.1407 22.8023 40.0642 23.1528 39.921 23.4778C39.7778 23.8029 39.5708 24.096 39.3123 24.3396L34.7142 28.6756L38.1922 38.6665C38.4722 39.4688 38.2676 40.3636 37.6661 40.9651C37.5426 41.0885 37.3943 41.1843 37.2311 41.2462C37.0678 41.3081 36.8933 41.3347 36.719 41.3242C36.5447 41.3136 36.3747 41.2663 36.22 41.1852C36.0654 41.1041 35.9297 40.9912 35.822 40.8538L29.853 33.2595L26.1997 36.7055L27.002 38.4318C27.1505 38.7514 27.1972 39.1089 27.1358 39.4559C27.0744 39.8029 26.9079 40.1227 26.6588 40.3721C26.5472 40.4837 26.4146 40.5722 26.2688 40.6326C26.1229 40.693 25.9665 40.724 25.8087 40.7239C25.6508 40.7238 25.4945 40.6926 25.3487 40.6321C25.2029 40.5715 25.0704 40.4829 24.9589 40.3711L23.5673 38.9795L22.6443 39.5839C22.3211 39.7956 21.9349 39.8896 21.5505 39.85C21.1662 39.8104 20.8072 39.6396 20.534 39.3664C20.2608 39.0932 20.09 38.7342 20.0504 38.3499C20.0108 37.9655 20.1048 37.5793 20.3165 37.2561L20.9218 36.334L19.5283 34.9405C19.0947 34.5068 19.0617 33.8271 19.4284 33.3547L19.5283 33.2416C19.7775 32.9929 20.097 32.8266 20.4436 32.7653C20.7902 32.7039 21.1474 32.7504 21.4668 32.8984L23.194 33.6979L26.6268 30.0577L19.1475 24.1793C19.1281 24.1642 19.1093 24.1484 19.0909 24.1322L19.0371 24.0822C18.5554 23.6004 18.5554 22.8179 19.0371 22.3361C19.5887 21.7846 20.3854 21.5668 21.133 21.7487L21.3357 21.81L31.1768 25.2343L35.5608 20.5863C36.0439 20.0742 36.7107 19.775 37.4144 19.7545C38.118 19.734 38.8011 19.9939 39.3132 20.4769L39.3688 20.5306Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2177_21707",
    x1: 0.0000504174,
    y1: 30.0001,
    x2: 723.196,
    y2: -596.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ACD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727042,
    stopColor: "#6940F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2177_21707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarter);
export default __webpack_public_path__ + "static/media/starter.599811dd3270c76efdfd102bce54ed99.svg";
export { ForwardRef as ReactComponent };